import React, { useMemo } from "react";
import { Form, Row, Col, FormGroup, Input, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "components/Select";
import { getActiveColorStyle } from "utils/colorUtils";
import {
  getTheme2SearchFilterColProps,
  getTheme2SearchFilterSingleSelectStyles,
} from "utils/theme2MultiSelect";

const STATUS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const TenantListFilters = ({
  activeColor = "secondary",
  isTheme2 = false,
  searchTerm,
  onSearchChange,
  filterStatus,
  onFilterStatusChange,
  searchPlaceholder,
}) => {
  const { t } = useTranslation();
  const activeColorStyle = useMemo(() => getActiveColorStyle(activeColor), [activeColor]);
  const filterSelectStyles = useMemo(
    () => getTheme2SearchFilterSingleSelectStyles(activeColorStyle, isTheme2),
    [activeColorStyle, isTheme2]
  );
  const filterColProps = getTheme2SearchFilterColProps(isTheme2, {
    filterColClass: "search-tenants-filter-col",
    md: "6",
  });
  const statusColProps = getTheme2SearchFilterColProps(isTheme2, {
    filterColClass: "search-tenants-filter-col",
    md: "3",
  });

  return (
    <Form>
      <Row className={isTheme2 ? "search-tenants-filters-row" : "mb-3"}>
        <Col {...filterColProps}>
          <FormGroup>
            <Label>{t("searchDeals.search")}:</Label>
            <Input
              type="text"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="form-control"
            />
          </FormGroup>
        </Col>
        <Col {...statusColProps}>
          <FormGroup>
            <Label>Status:</Label>
            <Select
              activeColor={activeColor}
              className="react-select"
              styles={filterSelectStyles}
              placeholder="All"
              name="statusFilter"
              isSearchable={false}
              closeMenuOnSelect={true}
              value={STATUS_OPTIONS.find((opt) => opt.value === filterStatus)}
              onChange={(option) => onFilterStatusChange(option?.value || "all")}
              options={STATUS_OPTIONS}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default TenantListFilters;
